import React, { Fragment } from 'react'
import { FormTextArea } from '@myxplor/forms'
import EnrolmentBookingSchedule from './enrolment-booking-schedule'
import CommonEnrolmentFields from './common-fields'

const CwaFields = props => {
  const { values, onChange } = props
  return (
    <Fragment>
      The only type of arrangement that can enable families to receive Child Care Subsidy.
      <CommonEnrolmentFields {...props}>
        {values.parent_id && (
          <Fragment>
            <EnrolmentBookingSchedule parent_id={values.parent_id} {...props} />
            <FormTextArea
              name="enrolment_params.agreement_conditions"
              value={values.enrolment_params.agreement_conditions}
              label="Additional Conditions"
              hint="Special conditions, e.g. if the parent is eligible for a staff discount"
              onChange={onChange}
              rows="2"
            />
          </Fragment>
        )}
      </CommonEnrolmentFields>
    </Fragment>
  )
}

export default CwaFields



// WEBPACK FOOTER //
// ./src/care-enrolments/details/ccs-gov-enrolments/actions/create-enrolment/cwa-fields.js